module.exports = __webpack_public_path__ + "img/25km²-2.0956f1ab.png";